import React, { useEffect, useState } from 'react'
import Header from '../../../common/header/Header'
import User_Dashbaord_Common_Section from '../user_dashboard_common_section/User_Dashbaord_Common_Section'
import { Add_To_Fav, get_favourite_product_list, Add_To_Cart } from '../../../../api/category_product/Category_Product';
import { User_Authentication } from '../../../../user_authentication/User_Authentication';
import { toast } from 'react-toastify'
import Loader from '../../../../loader/Loader';
import { IMG_BASE_URL } from '../../../../config/Config';
import { Link, useNavigate } from 'react-router-dom';
import { MdShoppingCart } from "react-icons/md";
import { MdDelete } from "react-icons/md";

import { useDispatch, useSelector } from 'react-redux';
import { fetchWishlist } from '../../../../redux/actions/wishlistActions';
import { fetchCartList } from '../../../../redux/actions/cartActions'







const User_Dashboard_Wishlist = () => {
    const date = new Date();
    const [is_loading, set_Is_Loading] = useState(false)
    const dispatch = useDispatch();
    const { wishlist = [] } = useSelector((state) => state.wishlist || {});
    const Get_user_is_active = localStorage.getItem("user_is_active")
    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 10;

    const navigate = useNavigate();

    // Calculate total pages safely
    const totalPages = Math.ceil(wishlist?.length / productsPerPage) || 1;

    // Calculate the products to display on the current page
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentProduct = wishlist?.slice(startIndex, startIndex + productsPerPage) || [];

    // Pagination controls
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    // const handle_get_favourite_product_list = async () => {
    //     try {
    //         const token = User_Authentication();
    //         if (!token) {
    //             toast("User token not found")
    //             set_Is_Loading(false)
    //             throw new Error("User token not found");
    //         }
    //         const response = await get_favourite_product_list({ Authorization: `Bearer ${token}` });
    //         if (response?.data?.status == "200") {
    //             set_WishList(response?.data?.data?.favourite);

    //         }
    //     }
    //     catch (error) {
    //         console.log(error?.message);

    //     }
    // }

    // <--------- Add To Favorite --------->
    const Handle_add_to_favorite = async (cat_id, sub_id, id) => {
        set_Is_Loading(true)
        const data = {
            cat_id: cat_id,
            subcat_id: sub_id,
            product_id: id
        }
        try {
            const token = User_Authentication();
            if (!token) {
                toast("User not login here")
                set_Is_Loading(false);
                throw new Error("User token not found");
            }
            if (!Get_user_is_active) {
                set_Is_Loading(false);
                toast("User not login here")
                return
            }
            const response = await Add_To_Fav(data, { Authorization: `Bearer ${token}` })
            if (response?.status == 200) {

                // await handle_get_favourite_product_list({ Authorization: `Bearer ${token}` })
                set_Is_Loading(false)
                dispatch(fetchWishlist())

                toast("remove the product from wishlist !!")
            }
            else if (response?.response?.data?.status == "500") {
                set_Is_Loading(false)
                toast(response?.response?.data?.message)
            }
        }
        catch (error) {
            console.error("error", error)
            set_Is_Loading(false)
        } finally {
            set_Is_Loading(false)
        }
    }

    // Format the date
    const formattedDate = (isoString) => {
        const date = new Date(isoString);
        const dateOptions = {
            year: 'numeric',
            month: 'short',
            day: '2-digit'
        };
        const timeOptions = {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };
        const formattedDate = new Intl.DateTimeFormat('en-US', dateOptions).format(date);
        const formattedTime = new Intl.DateTimeFormat('en-US', timeOptions).format(date);
        return `${formattedDate} | ${formattedTime}`;
    };

    // useEffect(() => {
    //     handle_get_favourite_product_list();
    // }, [])

    useEffect(() => {
        const get_wishlist = async () => {
            const result = await dispatch(fetchWishlist());
            if (result?.unauthorized) {
                localStorage.removeItem("user_token");
                localStorage.removeItem("user_is_active");
                toast("Token Expired. Please Login Again.");
                navigate("/user-login");

            }
        }
        get_wishlist();
    }, [dispatch]);


    const Handle_Add_To_cart = async (product_result) => {

        const data = {
            certificate: product_result?.certificate || null,
            energization: product_result?.energization || null,
            quantity: 1,
            product_id: product_result?.product_id
            ,
            base_price: product_result?.product?.seller_price,
            total_price: product_result?.product?.seller_price,

        };

        try {
            const token = User_Authentication();

            if (!token) {
                set_Is_Loading(false);
                toast.error("User is not logged in.")
                setTimeout(() => {
                    navigate("/user-login")
                }, 1000);
                // throw new Error("User token not found");
            }


            const response = await Add_To_Cart(data, { Authorization: `Bearer ${token}` })
            if (response?.data?.status == "200") {
                toast("Successfully add to product")
                dispatch(fetchCartList());

                await Handle_add_to_favorite(product_result?.cat_id, product_result?.subcat_id, product_result?.product_id)                // await Get_Cart_List({ Authorization: `Bearer ${token}` })

                // window.location.reload()
                navigate("/cart")
            }
            else if (response?.response?.data?.status == "500") {
                toast.warning(response?.response?.data?.message
                )
            }
        } catch (error) {
        }
    }


    return (
        <div>
            {/* <----------- Header section's ------------> */}
            <Header />
            {/* <-------- ToastContainer ------------> */}
            {/* <--------- user Wishlist section's ----------> */}
            {
                is_loading ? (
                    <Loader />
                ) : (
                    <>
                        <section className="gi-faq py-[40px] max-[767px]:py-[30px] gi-wishlist">
                            <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                <div className="section-title-2 w-full pb-[20px] flex flex-col justify-center items-center">
                                    <h1 className="gi-title mb-[0] text-[26px] font-semibold text-[#4b5966] relative inline p-[0] capitalize leading-[1]">Product <span className="text-[#9D2326]">Wishlist</span></h1>
                                    <p className="max-w-[400px] mt-[15px] text-[14px] text-[#777] text-center leading-[23px]">Your product wish is our first priority.</p>
                                </div>
                                <div className="w-full">
                                    <div className="w-full mb-10">

                                        <div className="w-full bg-white shadow-xl p-5">

                                            <div className="my_account w-full md:space-x-10 flex">
                                                <User_Dashbaord_Common_Section />
                                                <div className="flex-1 lg:w-[70%] mt-5 overflow-y-scroll w-[calc(80vw-30px)]" >
                                                    <div className="item-body dashboard-wrapper w-full">
                                                        <div className="relative w-full overflow-x-auto sm:rounded-lg">
                                                            {
                                                                wishlist?.length > 0 ? (
                                                                    <>
                                                                        <table className="table w-full mb-[1rem]">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th scope="col" className="p-[0.5rem] text-left text-gray-800 font-semibold text-[12px]">ID</th>
                                                                                    <th scope="col" className="p-[0.5rem] text-left text-gray-800 font-semibold text-[12px]">Image</th>
                                                                                    <th scope="col" className="p-[0.5rem] text-left text-gray-800 font-semibold text-[12px]">Name</th>
                                                                                    <th scope="col" className="p-[0.5rem] text-left text-gray-800 font-semibold text-[12px]">Date</th>
                                                                                    <th scope="col" className="p-[0.5rem] text-left text-gray-800 font-semibold text-[12px]">Price</th>
                                                                                    <th scope="col" className="p-[0.5rem] text-left text-gray-800 font-semibold text-[12px]">Status</th>
                                                                                    <th scope="col" className="p-[0.5rem] text-left text-gray-800 font-semibold text-[12px]">Actions</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody className="wish-empt border-t-[3px] border-solid border-[#eee] border-solid border-[#dee2e6]">
                                                                                {
                                                                                    currentProduct?.map((wishlist_result, index) => {
                                                                                        return (
                                                                                            <tr className="pro-gl-content">
                                                                                                <td className="p-[0.5rem] border-b-[1px] border-solid border-[#dee2e6] text-[12px] font-medium"><span className=" py-[14px] flex text-[#777] tracking-[0.02rem]">{index + 1}</span></td>
                                                                                                <td className="p-[0.5rem] border-b-[1px] border-solid border-[#dee2e6] text-[12px] font-medium"><img className="prod-img h-[40px] w-[40px]" src={`${IMG_BASE_URL}${wishlist_result?.product?.single_image?.image_url}`} alt="product image" /></td>
                                                                                                <td className="p-[0.5rem] border-b-[1px] border-solid border-[#dee2e6] text-[12px] font-medium"><span className=" py-[14px] flex text-[#777] tracking-[0.02rem]">{wishlist_result?.product?.name}</span></td>
                                                                                                <td className="p-[0.5rem] border-b-[1px] border-solid border-[#dee2e6] text-[12px] font-medium"><span className=" py-[14px] flex text-[#777] tracking-[0.02rem]">{formattedDate(wishlist_result?.created_at)}</span></td>
                                                                                                <td className="p-[0.5rem] border-b-[1px] border-solid border-[#dee2e6] text-[12px] font-medium"><span className=" py-[14px] flex text-[#777] tracking-[0.02rem]">Rs.{wishlist_result?.product?.purchase_price}</span></td>
                                                                                                {
                                                                                                    wishlist_result?.product?.current_stock > 0 ? (
                                                                                                        <td className="p-[0.5rem] border-b-[1px] border-solid border-[#dee2e6] text-[12px] font-medium"><span className=" py-[14px] flex text-[#5caf90] tracking-[0.02rem]">Available</span></td>
                                                                                                    ) : (
                                                                                                        <td className="p-[0.5rem] border-b-[1px] border-solid border-[#dee2e6] text-[12px] font-medium"><span className=" py-[14px] flex text-red-600 tracking-[0.02rem]">Out of Stock</span></td>
                                                                                                    )
                                                                                                }
                                                                                                <td className="p-[0.5rem] border-b-[1px] border-solid border-[#dee2e6] text-[12px] font-medium" >
                                                                                                    <div className='flex justify-between'>


                                                                                                        <span className="tbl-btn py-[14px] flex text-[#777] "

                                                                                                        >
                                                                                                            {/* <button type='button' className="w-full text-[12px] uppercase rounded text-center px-3 py-1.5 inline-block  border-gray-900 text-white hover:border-gray-900 bg-red-500
                                                                                                    hover:bg-red-800" title="Add To Cart">
                                                                                                            Remove
                                                                                                        </button> */}
                                                                                                            <MdDelete size={20} className="text-red-600 cursor-pointer"
                                                                                                                onClick={() => {
                                                                                                                    Handle_add_to_favorite(wishlist_result?.cat_id, wishlist_result?.subcat_id, wishlist_result?.product_id)
                                                                                                                }} />
                                                                                                        </span>
                                                                                                        <span className="tbl-btn py-[14px] flex text-[#777]"
                                                                                                        >
                                                                                                            {/* <button type='button' className="w-full text-[12px] uppercase rounded text-center px-3 py-1.5 inline-block border border-gray-900 text-gray-700 hover:text-white hover:border-gray-900 hover:bg-gray-900" title="Add To Cart">
                                                                                                            Add to Cart
                                                                                                        </button> */}

                                                                                                            <MdShoppingCart size={20} className="text-green-800 cursor-pointer"
                                                                                                                onClick={() => {
                                                                                                                    Handle_Add_To_cart(wishlist_result)
                                                                                                                }} />
                                                                                                        </span>
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </tbody>
                                                                        </table>
                                                                        {/* <!-- Pagination Start --> */}
                                                                        <div className="gi-pro-pagination pt-[15px] pb-[15px] flex justify-between items-center border-t-[1px] border-solid border-[#eee] max-[575px]:flex-col">
                                                                            <span className="text-[14px] text-[#777] max-[575px]:mb-[10px]">Showing {startIndex + 1}-{Math.min(startIndex + productsPerPage, currentProduct?.length)} of {currentProduct?.length} Product(s)</span>
                                                                            <ul className="gi-pro-pagination-inner flex">
                                                                                {currentPage > 1 && (
                                                                                    <li>
                                                                                        <button
                                                                                            onClick={handlePrev}
                                                                                            className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-[#5caf90] leading-[30px] h-[32px] bg-red-500 flex text-center align-top text-[16px] justify-center items-center rounded-[5px]"
                                                                                        >
                                                                                            Prev
                                                                                        </button>
                                                                                    </li>
                                                                                )}
                                                                                {[...Array(totalPages).keys()].map((page) => (
                                                                                    <li key={page} className="inline-block float-left mr-[5px]">
                                                                                        <button
                                                                                            onClick={() => handlePageChange(page + 1)}
                                                                                            className={`transition-all duration-[0.3s] m-1 p-2 ease-in-out w-[32px] h-[32px] font-light 
                    text-[#777] leading-[32px] bg-[#eee] flex text-center align-top 
                    text-[16px] justify-center items-center rounded-[5px]
                    ${currentPage === page + 1 ? 'active bg-red-500 text-white' : 'bg-gray-300 text-white'}`}
                                                                                        >
                                                                                            {page + 1}
                                                                                        </button>
                                                                                    </li>
                                                                                ))}
                                                                                {currentPage < totalPages && (
                                                                                    <li>
                                                                                        <button
                                                                                            onClick={handleNext}
                                                                                            className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-[#5caf90] leading-[30px] h-[32px] bg-red-500 flex text-center align-top text-[16px] justify-center items-center rounded-[5px]"
                                                                                        >
                                                                                            Next
                                                                                        </button>
                                                                                    </li>
                                                                                )}
                                                                            </ul>

                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <div className='flex flex-col items-center justify-center py-10 w-full'>
                                                                        <h5 className="mb-4 text-gray-500 font-semibold text-lg uppercase">Your Wishlist is Empty</h5>
                                                                        <Link to="/all-best-selling-product" className="px-6 py-2 bg-[#9D2326] text-white rounded-md hover:bg-black transition-all">
                                                                            Explore Best Sellers
                                                                        </Link>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </>
                )
            }
        </div >
    )
}

export default User_Dashboard_Wishlist